import { useEffect, useState } from 'react';

const REDUCED_MOTION_QUERY = '(prefers-reduced-motion: reduce)';

const isBrowserEnvironment = (): boolean => typeof window !== 'undefined' && typeof window.matchMedia === 'function';

export function usePrefersReducedMotion(): boolean {
    const [prefersReducedMotion, setPrefersReducedMotion] = useState(false);

    useEffect(() => {
        if (!isBrowserEnvironment()) {
            return;
        }

        const mediaQueryList = window.matchMedia(REDUCED_MOTION_QUERY);
        const handleChange = (event?: MediaQueryListEvent) => {
            setPrefersReducedMotion(event?.matches ?? mediaQueryList.matches);
        };

        handleChange();

        if (typeof mediaQueryList.addEventListener === 'function') {
            mediaQueryList.addEventListener('change', handleChange);
            return () => mediaQueryList.removeEventListener('change', handleChange);
        }

        mediaQueryList.addListener(handleChange);
        return () => mediaQueryList.removeListener(handleChange);
    }, []);

    return prefersReducedMotion;
}
